import { render, staticRenderFns } from "./CallRT.vue?vue&type=template&id=c328740a&scoped=true"
import script from "./CallRT.vue?vue&type=script&lang=js"
export * from "./CallRT.vue?vue&type=script&lang=js"
import style0 from "./CallRT.vue?vue&type=style&index=0&id=c328740a&prod&scoped=true&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c328740a",
  null
  
)

export default component.exports